export default {
	namespaced: true,
	state: () => ({
		componentStep: 1,
		skipPassportStep: false,
	}),
	mutations: {
		SET_COMPONENT_STEP(state, val) {
			state.componentStep = val;
		},
		SET_SKIP_PASSPORT_STEP(state, val) {
			state.skipPassportStep = val;
		},
	},
};
